import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { StudyMemberDto } from '@interfaces-clean/study-member.interface';
import { getData } from '@apis/rest-client';

const studyMemberUrl = 'SubjectMonitoring/StudyMember';
const fetchOptions = { timeout: 30000 };

export const SubjectMonitoringStudyMemberApi = {
    useLazyGet: (studyRef: string) => {
        const url = `${studyMemberUrl}/${studyRef}`;
        return useSWRMutation(url, (getDataUrl: string) => {
            return getData<StudyMemberDto[]>(getDataUrl, fetchOptions);
        });
    },

    useGetAllStudyMembers: (studyRef: string, includeInactive: boolean) => {
        const url = `${studyMemberUrl}/${studyRef}?includeInactive=${includeInactive}`;
        return useSWR(url, (getDataUrl: string) => {
            return getData<StudyMemberDto[]>(getDataUrl, fetchOptions);
        });
    },
} as const;
